import "uuid";
const jsonMimeType = "application/json";
const acceptJson = {
  Accept: jsonMimeType
};
const postJson = {
  "Content-Type": jsonMimeType
};
const authHeader = (accessToken) => ({
  Authorization: `Bearer ${accessToken}`
});
export {
  acceptJson,
  authHeader,
  postJson
};
//# sourceMappingURL=shared.js.map
